import { create } from 'zustand';

interface DocsActionBarState {
  docId: string | undefined;
  setDoc: (docId: string) => void;
}

const docsActionBarState = create<DocsActionBarState>((set, get) => ({
  docId: undefined,
  setDoc: (docId: string) => {
    set({ docId });
  },
}));

export const useDocsActionBarState = docsActionBarState;
